import React, { useState, useEffect, useRef } from 'react';
import s from './autocomplete.module.css';
import { FaSearch } from 'react-icons/fa';
import { Link, navigate } from 'gatsby';

const KEY_ARROW_UP = 38;
const KEY_ARROW_DOWN = 40;
const KEY_ENTER = 13;

const renderSuggestions = (suggestions, cursor) => {
    return (
        <ul className={s.suggestions}>
            {
                suggestions.map((sug, index) => {
                    return (
                        <li key={`sug-${index}`} className={s.suggestion}>
                            <Link className={index === cursor ? s.suggestion_link_active : ''} to={sug.link}>
                                {sug.text}
                            </Link>
                        </li>
                    );
                })
            }
        </ul>
    );
};

/**
 * Implementacion de autofocus:
 * https://stackoverflow.com/questions/28889826/set-focus-on-input-after-render
 */
const useFocus = () => {
    const htmlRef = useRef(null);
    const setFocus = () => { htmlRef.current && htmlRef.current.focus() }

    return [ htmlRef, setFocus ];
}

const Autocomplete = ({ suggestions, className, isOpen, isDesktop }) => {
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [userInput, setUserInput] = useState('');
    const [cursor, setCursor] = useState(-1);
    const [searchInputRef, setInputFocus] = useFocus();

    useEffect(() => {
        if (isOpen) {
            setInputFocus();
        }
    });

    const onChange = (evt) => {
        const userInput = evt.currentTarget.value;
        setUserInput(userInput);

        if (userInput.length > 2) {
            const filteredSuggestions = suggestions.filter(
                ({ text, tags }) => {
                    const searchText = userInput.toLowerCase();
                    return text.toLowerCase().indexOf(searchText) > -1
                        || (tags && tags.length && tags.toLowerCase().indexOf(searchText) > -1)
                }
            );

            setFilteredSuggestions(filteredSuggestions);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const onKeyDown = evt => {
        const total = filteredSuggestions.length;
        switch (evt.keyCode) {
            case KEY_ARROW_DOWN: setCursor(cursor + 2 > total ? 0 : cursor + 1); break;
            case KEY_ARROW_UP: setCursor(cursor - 1 < 0 ? total - 1 : cursor - 1); break;
            case KEY_ENTER: navigate(filteredSuggestions[cursor].link); break;
            default: return;
        }
    };

    const resetSearch = () => {
        setShowSuggestions(false);
        setUserInput('');
    };

    return (
        <div className={className}>
            <div className={s.autocomplete}>
                <input
                    ref={searchInputRef}
                    placeholder='Ingresa tu búsqueda'
                    className={`${s.search} c-gray--1 pv-2 ph-3 fw-0`}
                    type='text'
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    value={userInput}
                />
                {
                    showSuggestions
                    ? renderSuggestions(filteredSuggestions, cursor)
                    : null
                }

                {// Ocultar boton 'X' en MOBILE
                    !isDesktop && <FaSearch className={`${s.autocomplete_btn_search}`} />
                }

                {// Mostrar botón 'X' en MOBILE
                    !isDesktop && showSuggestions && (
                        <button
                            className={`c-gray--1 ' ${s.autocomplete_close}`}
                            title='Cerrar'
                            onClick={() => resetSearch()}>
                            ✖
                        </button>
                    )
                }
            </div>
        </div>
    );
};

export default Autocomplete;
